var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('document-icon',{attrs:{"doc":_vm.doc}}),_vm._v(_vm._s(_vm.title)+"\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }